import api from '../../apiConfig/apiConfig';
import { Get, Post } from '../base/baseAjax';
export default {
	chatList(param) {
		return Post({
			url: api.liveChat.chatList,
			bodyParam: param,
			config: {
				timeout: 60000,
			},
		});
	},
	headerDetail(param) {
		return Get({
			url: api.liveChat.headerDetail,
			PathParam: param,
		});
	},
	chatRecord(param) {
		return Post({
			url: api.liveChat.chatRecord,
			bodyParam: param,
			config: {
				timeout: 1000000,
			},
		});
	},
	whatsappChatRecord(param) {
		return Post({
			url: api.liveChat.whatsappChatRecord,
			bodyParam: param,
			config: {
				timeout: 1000000,
			},
		});
	},
	chatToSent(param) {
		return Post({
			url: api.liveChat.chatToSent,
			bodyParam: param,
		});
	},
	autograph() {
		return Get({
			url: api.liveChat.autograph,
		});
	},
	jpushimuser(param) {
		return Post({
			url: api.liveChat.jpushimuser,
			bodyParam: param,
		});
	},
	chatNum() {
		return Get({
			url: api.liveChat.chatNum,
		});
	},
	chatManual(param) {
		return Post({
			url: api.liveChat.chatManual,
			PathParam: param,
		});
	},
	addchatAccount() {
		return Post({
			url: api.liveChat.addchatAccount,
		});
	},
	bindhomepage() {
		return Get({
			url: api.liveChat.bindhomepage,
		});
	},
	chatSend(param) {
		return Post({
			url: api.liveChat.chatSend,
			bodyParam: param,
			config: {
				timeout: 1000000,
			},
		});
	},
	assignment(param) {
		return Post({
			url: api.liveChat.assignment,
			bodyParam: param,
		});
	},
	attrDetails(param) {
		return Get({
			url: api.liveChat.attrDetails,
			PathParam: param,
		});
	},
	getContactlist(param) {
		return Get({
			url: api.liveChat.getContactlist,
			PathParam: param,
		});
	},
};
